<template>
	<section class="layout-standard">
		<slot name="header">
			<ViewLayoutHeader />
		</slot>

		<slot>
			<transition name="fade">
				<!-- mk: Doing this might mess with things like map coordinates -->
				<!-- <router-view v-bind:key="$route.fullPath" /> -->
				<router-view />
			</transition>
		</slot>

		<slot name="footer">
			<ViewLayoutNavigationTabs />
			<ViewLayoutActionPanel />
		</slot>
	</section>
</template>

<script lang="ts">
	import LayoutBase from '@/Core/Layout.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Standard layout with header, content area, and navigation tabs.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class LayoutStandard extends LayoutBase {
		//
	}
</script>

<style lang="scss">
	.layout-standard {
		--app-max-width: 1024px;

		background-color: var(--chalky-blue-4);
		height: 100%;
		overflow: hidden;
		position: absolute;
		width: 100%;

		.page[class*='page-'] {
			// bottom: var(--global-tab-height); // calc(var(--global-tab-height) + env(safe-area-inset-bottom));
			bottom: max(var(--global-tab-height));
			left: 0;
			min-height: auto;
			overflow: auto;
			position: absolute;
			right: 0;
			top: 0;
		}

		#GlobalHeader {
			padding-top: max(env(safe-area-inset-top), 1.5rem);
			position: fixed;
			top: 0; // env(safe-area-inset-top);
			width: 100%;
			z-index: var(--z-header-top);

			.branding-standard {
				margin-top: -5px;
			}
		}
	}

	// Variations
	// ---------------------------------------------------------------------------

	#app.state-keyboard .layout-standard {
		.page[class*='page-'] {
			bottom: 0;
		}
	}

	// State
	// ---------------------------------------------------------------------------

	.show-global-menu .layout-standard {
		.page {
			filter: blur(2px);
			opacity: 0.25;
			pointer-events: none;
		}
	}
</style>
